import {
	createContext,
	type FC,
	type ReactNode,
	useContext,
	useRef,
} from "react";

const EntityLabelsContext = createContext<{
	labels: Map<string, string>;
	set: (value: string, label: string) => void;
}>({ labels: new Map(), set: (_value, _label) => {} });

export interface EntityLabelsProviderProps {
	children: ReactNode;
}

export const EntityLabelsProvider: FC<EntityLabelsProviderProps> = ({
	children,
}) => {
	const labelsRef = useRef(new Map());

	const set = (value: string, label: string) => {
		console.log(value, label);
		labelsRef.current.set(value, label);
	};

	return (
		<EntityLabelsContext.Provider value={{ labels: labelsRef.current, set }}>
			{children}
		</EntityLabelsContext.Provider>
	);
};

export const useEntityLabels = (): {
	labels: Map<string, string>;
	set: (value: string, label: string) => void;
} => {
	return useContext(EntityLabelsContext);
};
